import { env } from 'app/env'

import { buildRoute, Route } from './build-route'
import { paths } from './paths'

export const unauthRoutes: Array<Route> = [
  buildRoute({
    path: paths.signIn,
    factory: () => import('pages/sign-in'),
    title: 'sign_in.sign_in',
  }),
  ...(env.REACT_APP_SIGN_UP_AVAILABLE === 'true'
    ? [
        buildRoute({
          path: paths.signUp,
          factory: () => import('pages/sign-up'),
          title: 'sign_up.sign_up',
        }),
      ]
    : []),
  buildRoute({
    path: paths.forgotPassword,
    factory: () => import('pages/forgot-password'),
    title: 'forgot_password.forgot_password',
  }),
  buildRoute({
    path: paths.resetPassword,
    factory: () => import('pages/reset-password'),
    title: 'common.reset_your_password',
  }),
  buildRoute({
    path: paths.signUpConfirmation,
    factory: () => import('pages/sign-up-confirmation'),
    title: 'sign_up.sign_up_confirmation',
  }),
  buildRoute({
    path: paths.invitationConfirmation,
    factory: () => import('pages/invitation-confirmation'),
    title: 'complete_registration.complete_registration',
  }),
  buildRoute({
    path: paths.emailChangeConfirmation,
    factory: () => import('pages/email-change-confirmation'),
  }),
  buildRoute({
    path: paths.googleAuthRedirect,
    factory: () => import('pages/google-auth-redirect'),
  }),
]
